import React from "react";
import CourseNote from "../../components/content/course-note/CourseNote";
import EducationalBooklet from "../../components/content/educational-booklet/EducationalBooklet";
import SampleTeaching from "../../components/content/sample-teaching/SampleTeaching";
import RowBanner from "../../components/shared/row-banner/RowBanner";
import "./StudentExtraCurricularRoute.scss";
import LeitnerImage from "../../assest/images/extraCurricular/leithner.svg";
import Darsnameh from "../../assest/images/extraCurricular/darsnameh.svg";
import Jozveh from "../../assest/images/extraCurricular/jozveh.svg";
import NemouneTadris from "../../assest/images/extraCurricular/nemouneTadris.svg";

export default class StudentExtraCurricularRoute extends React.PureComponent<
  { statusPage?: string | null },
  { statusPage: number }
> {
  constructor(props: any) {
    super(props);
    this.state = { statusPage: 0 };
  }

  componentDidMount() {
    if (this.props.statusPage !== null && this.props.statusPage !== undefined)
      this.setState({ statusPage: Number.parseInt(this.props.statusPage) });
  }

  componentDidUpdate(prevProps: any) {
    if (
      prevProps.statusPage !== this.props.statusPage &&
      this.props.statusPage !== null &&
      this.props.statusPage !== undefined
    )
      this.setState({ statusPage: Number.parseInt(this.props.statusPage) });
  }

  render(): React.ReactNode {
    let { statusPage } = this.state;

    let content;
    if (statusPage === 0) {
      content = (
        <>
          <div className="dropdown-list  student-extra-curricular-route-area">
            <div className="col-12 col-md-12 pt-2">
              <div className="row" style={{ margin: "0" }}>
                <div className="col-12 col-md-12 px-0">
                  <RowBanner
                    bannerDetail={{
                      redirectLink: "/LeitnerBoxs",
                      title: "جعبه لایتنر",
                      imageSource: LeitnerImage,
                    }}
                  />
                </div>
                <div className="col-12 col-md-12 px-0">
                  <RowBanner
                    bannerDetail={{
                      redirectLink: "/CourseNote",
                      title: "تدریس های برنده ساز",
                      imageSource: Darsnameh,
                    }}
                  />
                </div>
                <div
                  className="col-12 col-md-12 px-0 disabled-area"
                  aria-disabled
                >
                  <RowBanner
                    bannerDetail={{
                      redirectLink: "/EducationalBooklet",
                      title: "کوچینگ من",
                      imageSource: Jozveh,
                    }}
                  />
                </div>
                <div className="col-12 col-md-12  px-0">
                  <RowBanner
                    bannerDetail={{
                      redirectLink: "/SampleTeaching",
                      title: "نکات مشاوره‌ای",
                      imageSource: NemouneTadris,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      );
    } else content = this.tabViews(statusPage);

    return <>{content}</>;
  }

  tabViews(statusPage: number) {
    let content;
    if (statusPage === 1) {
      content = (
        <>
          <SampleTeaching />
        </>
      );
    } else if (statusPage === 2) {
      content = (
        <>
          <CourseNote />
        </>
      );
    } else if (statusPage === 3) {
      content = (
        <>
          <EducationalBooklet />
        </>
      );
    } else content = <></>;

    return (
      <>
        <div className="found-data student-extra-curricular-route-area">
          {content}
        </div>
      </>
    );
  }
}
